import gql from 'graphql-tag';

export default gql`
  mutation userRemove($id: ID!) {
    userRemove(id: $id) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
